"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountIntegrationFormSchema = exports.metaSchema = exports.AccountIntegrationSchema = exports.keyValuePairSchema = exports.fallbackPIISchema = exports.integrationTypeList = exports.IntegrationType = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const acceptedTypes = ['string', 'number', 'boolean'];
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["Trello"] = "trello";
    IntegrationType["RockSolid"] = "rock-solid";
    IntegrationType["SalesForce"] = "salesforce";
    IntegrationType["SalesforceV2"] = "salesforce-v2";
    IntegrationType["OneView"] = "oneview";
    IntegrationType["Seeclickfix"] = "seeclickfix";
    IntegrationType["GoGov"] = "gogov";
    IntegrationType["Accela"] = "accela";
    IntegrationType["GovQa"] = "govqa";
    IntegrationType["Granicus"] = "granicus";
    IntegrationType["MyCivic"] = "mycivic";
    IntegrationType["Munis"] = "munis";
})(IntegrationType || (exports.IntegrationType = IntegrationType = {}));
exports.integrationTypeList = Object.keys(IntegrationType).map((key) => ({
    label: key,
    value: IntegrationType[key]
}));
exports.fallbackPIISchema = yup_lib_1.default.object().shape({
    firstName: yup_lib_1.default.string().required(),
    lastName: yup_lib_1.default.string().required(),
    email: yup_lib_1.default.string().email().required(),
    phoneNumber: yup_lib_1.default.string().required(),
    address: yup_lib_1.default.string().required()
});
exports.keyValuePairSchema = yup_lib_1.default.object({
    key: yup_lib_1.default.string().required(),
    value: yup_lib_1.default.mixed().test({
        name: 'valid-value',
        message: 'Value must be a string, number, boolean, or object',
        test: function (value) {
            if (acceptedTypes.includes(typeof value) ||
                (typeof value === 'object' && !Array.isArray(value))) {
                return true;
            }
            return this.createError({
                path: this.path,
                message: 'Value must be a string, number, boolean, or object'
            });
        }
    })
});
exports.AccountIntegrationSchema = yup_lib_1.default.object({
    account: yup_lib_1.default.string().required(),
    integrationType: yup_lib_1.default.mixed().oneOf(Object.values(IntegrationType)).required(),
    mappingDoc: yup_lib_1.default.mixed().optional(),
    meta: yup_lib_1.default.object().optional(),
    intents: yup_lib_1.default.array().of(yup_lib_1.default.string().required()).optional(),
    defaultPersonalData: exports.fallbackPIISchema.required()
});
exports.metaSchema = yup_lib_1.default.object({
    keyValues: yup_lib_1.default
        .array()
        .of(yup_lib_1.default.object().shape({
        key: yup_lib_1.default.string().required('Key is required'),
        value: yup_lib_1.default.string().required('Value is required')
    }))
        .min(1, 'Configuration is required')
});
exports.AccountIntegrationFormSchema = yup_lib_1.default.object({
    account: yup_lib_1.default.string().required(),
    integrationType: yup_lib_1.default.mixed().oneOf(Object.values(IntegrationType)).required(),
    mappingDoc: yup_lib_1.default.mixed().optional(),
    meta: exports.metaSchema,
    intents: yup_lib_1.default.array().of(yup_lib_1.default.string().required()).optional(),
    defaultPersonalData: exports.fallbackPIISchema.optional()
});
